import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import { ExcelReportsJson } from "../../DynamicFormsJson/MastersJSON/excelReports";

import {
	getBelowSalesTeamList,
	getSalesExecutiveByUserType,
	getSalesExecutiveByUserTypeAndRegion,
} from "../../Slice/salesExecutive.slice";
import { getStockStakeHolderTypeBySalesTeamId } from "../../Slice/stockStakeHolderType.slice";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicReportGenerate";
import endpoint from "../../config/endpoints";
import {
	noInternetMsg,
	salesTeamExcelReportsNoteWith91DaysValidation,
	serverMsg,
} from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";

class ExcelReportsForSalesTeams extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dynamicMasterData: {
				stockStakeHolderTypeDetail:
					this.props.stockStakeHolderType?.stockStakeHolderType,
				salesPersonDetail: this.props.salesPersonList?.salesPersonByArea,
				salesPersonDetail: this.props.salesPersonList?.salesExecutiveBelowTeam,
			},
			reportIndexList: [],
			listForReports: [],
			salesTeamId: "",
			uniqueReportSet: [],
		};
	}

	async componentDidMount() {
		const {
			getSalesExecutiveByUserType,
			getSalesExecutiveByUserTypeAndRegion,
			showLoador,
			showNotification,
			getBelowSalesTeamList,
		} = this.props;

		if (!navigator.onLine) {
			showNotification({ msg: noInternetMsg, severity: "error" });
			return;
		}
		const moduleObjData = JSON.parse(localStorage.getItem("moduleObj"));
		const eventsList = moduleObjData?.events || [];

		this.setState({
			uniqueReportSet: new Set(eventsList.map((item) => item.functionalityId)),
		});

		const userTypeId = localStorage.getItem("userTypeId");
		const { salesTeamId } = this.state;

		let reportIndexList = [];

		const settingKey =
			userTypeId == 6
				? "showExcelReportsBySettingValuesForSubUser"
				: "showExcelReportsBySettingValues";

		reportIndexList =
			localStorage.getItem(settingKey) &&
			localStorage.getItem(settingKey).split(",");

		this.setState({ reportIndexList });

		showLoador({ loador: true });

		if (userTypeId == 6) {
			await getSalesExecutiveByUserTypeAndRegion({ userTypeId: "3,4" }).then(
				({ success, response }) => {
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				},
			);
		} else if (userTypeId == 1) {
			await getSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
				({ success, response }) => {
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				},
			);
		} else {
			await getBelowSalesTeamList({ salesTeamId, flag: "1" }).then(
				({ success, response }) => {
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				},
			);
		}

		showLoador({ loador: false });

		this.rowDataGklAdm(reportIndexList);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.salesPersonList !== nextProps.salesPersonList) {
			if (
				this.props.salesPersonList?.salesPersonByArea !==
				nextProps.salesPersonList?.salesPersonByArea
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						salesPersonDetail: nextProps.salesPersonList?.salesPersonByArea,
					},
				});
			}
		}

		if (this.props.salesPersonList !== nextProps.salesPersonList) {
			if (
				this.props.salesPersonList?.salesExecutiveBelowTeam !==
				nextProps.salesPersonList?.salesExecutiveBelowTeam
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						salesPersonDetail:
							nextProps.salesPersonList?.salesExecutiveBelowTeam,
					},
				});
			}
		}

		if (this.props.stockStakeHolderType !== nextProps.stockStakeHolderType) {
			if (
				this.props.stockStakeHolderType?.stockStakeHolderType !==
				nextProps.stockStakeHolderType?.stockStakeHolderType
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stockStakeHolderTypeDetail:
							nextProps.stockStakeHolderType?.stockStakeHolderType,
					},
				});
			}
		}
		if (this.props.stakeholderList !== nextProps.stakeholderList) {
			if (
				this.props.stakeholderList?.stackholderNameFromType !==
				nextProps.stakeholderList?.stackholderNameFromType
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stakeHolderName: nextProps.stakeholderList?.stackholderNameFromType,
					},
				});
			}
		}
	}

	getListById = async (data) => {
		const {
			showLoador,
			getStockStakeHolderTypeBySalesTeamId,
			showNotification,
		} = this.props;
		if (navigator.onLine) {
			this.setState({
				fromDate: dayjs(data.fromDate).format("DD-MM-YYYY"),
				toDate: dayjs(data.toDate).format("DD-MM-YYYY"),
			});

			if (data.salesPerson && data.salesPerson != "") {
				showLoador({ loador: true });
				await getStockStakeHolderTypeBySalesTeamId({
					salesTeamId: data.salesPerson,
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}
		} else {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
		}
	};

	getExcelByReport = async (row, rowData) => {
		const { showLoador, showNotification } = this.props;
		const { dynamicMasterData } = this.state;

		let salesPersonDetails = dynamicMasterData.salesPersonDetail.find(
			(dataObj) => dataObj.id === row.salesPerson,
		);

		let salesPersonName =
			salesPersonDetails !== null && salesPersonDetails?.name !== null
				? salesPersonDetails?.name
				: "";

		if (navigator.onLine) {
			if (rowData.uniqueIndexValue == 35) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/customer-additional-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Customer Addition Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 36) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
					flag: 1,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.reportForExcelReportsLatest + "/drpc-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "DRCP Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 37) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/attendence-summary-report-excel?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson,
					ext: "xls",
					openNewTab: false,
					reportName: "Attendance Summary Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 38) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/outlet-joint-survey-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Joint Working Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 39) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/check-in-out-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Check In Out Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 40) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/zero-billing-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Zero Billing Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 41) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.reportForExcelReportsLatest + "/fundamental-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Fundamental Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 42) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
					outletTypeIds: [],
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/wholesales-target-vs-achive-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Wholesale Target vs Achievement Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 43) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/travel-and-daily-allowance-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "TA & DA Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 44) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/stock-holder-wise-sales-team-with-target-and-achievement?salesTeamId=" +
						row.salesPerson +
						"&flag=0&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Sales Team Ranking (RU)",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 45) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/stock-holder-wise-sales-team-with-target-and-achievement?salesTeamId=" +
						row.salesPerson +
						"&flag=1&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Sales Team Ranking (Value)",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 46) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/fundamental-summary-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Fundamental Summary Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 47) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/target-vs-achievement-by-year-and-sales-team?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&flag=0",
					ext: "xls",
					openNewTab: false,
					reportName: "Target vs Achievement (RU)",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 48) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/target-vs-achievement-by-year-and-sales-team?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&flag=1",
					ext: "xls",
					openNewTab: false,
					reportName: "Target vs Achievement (Value)",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 49) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/secondary-sales-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Secondary Sales Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 50) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.exportDataNew + "/focus-sku-target-vs-achievement-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Focus SKU Target vs Achievement",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 52) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
					flag: 0,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.reportForExcelReportsLatest + "/drpc-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "DRCP Report for Inactive Sales Person",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 53) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest + "/unvisited-outlet-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Unvisited Outlet Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 54) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/check-in-out-summary-report",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Check In Out Summary Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 55) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/product-distribution-report?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson,
					ext: "xls",
					openNewTab: false,
					reportName: "Product Distribution Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 60) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
					flag: 1,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest + "/drpc-report-for-manager",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Active DRCP Report for Manager",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 61) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
					flag: 0,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest + "/drpc-report-for-manager",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Inactive DRCP Report for Manager",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 62) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/claim-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Claim Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 63) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/not-mapped-beat-sales-teams?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Not Mapped Beat Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 64) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/get-end-user-allowance-data?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "End User Allowance Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 65) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.monthlySalesBillAnalysis + "/new-by-sales-team",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Distributor Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 66) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/consolidated-expense-report-with-info?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson +
						"&stockStakeHolderTypeIds=" +
						row.stockStakeHolderTypeId,
					ext: "xls",
					openNewTab: false,
					reportName: "Expense Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 67) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/chef-outlet-joint-survey-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Chef Working Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 68) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/feedback-report?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson,
					ext: "xls",
					openNewTab: false,
					reportName: "Feedback Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 69) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/feedback-report-by-type?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson +
						"&type=0",
					ext: "xls",
					openNewTab: false,
					reportName: "Feedback Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 70) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/feedback-report-by-type?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson +
						"&type=1",
					ext: "xls",
					openNewTab: false,
					reportName: "Outlet Feedback Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 71) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/consolidated-expense-report-with-info-with-distance-travelled?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson +
						"&stockStakeHolderTypeIds=" +
						row.stockStakeHolderTypeId,
					ext: "xls",
					openNewTab: false,
					reportName: "Expense Report For Admin",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 74) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/sales-team-type-wise-attendence-summary-report-excel?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson +
						"&stockStakeHolderTypeIds=" +
						row.stockStakeHolderTypeId,
					ext: "xls",
					openNewTab: false,
					reportName: "Attendance Summary Report Team Type Wise",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 75) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/beat-without-mapped-to-end-user-report",
					ext: "xls",
					openNewTab: false,
					reportName: "Report For Beats Without Mapped End Users",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 76) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/daily-allowance-beat-master-report?salesTeamId=" +
						row.salesPerson,
					ext: "xls",
					openNewTab: false,
					reportName: "DA Beat Master Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 77) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/market-visit-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Market Visit Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 78) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/enquiry-master-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Enquiry Master Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 79) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/chef-outlet-joint-survey-sub-detail-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Chef Working Product Wise Detail Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 80) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.exportDataNew +
						"/promoter-outlet-joint-survey-report?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Market Visit Report In Detail",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 81) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/outlet-credit-note?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Outlet Credit Note report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						81;
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 82) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url: endpoint.exportDataNew + "/check-in-out-report-with-state",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Check In Out Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 83) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/fundamental-report-with-state",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Fundamental Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 84) {
				const dataToSave = {
					salesTeamId: row.salesPerson,
					fromDate: row.fromDate,
					toDate: row.toDate,
				};

				showLoador({ loador: true });
				downloadF({
					isGet: false,
					url:
						endpoint.reportForExcelReportsLatest +
						"/fundamental-summary-report-with-state",
					postBody: dataToSave,
					ext: "xls",
					openNewTab: false,
					reportName: "Fundamental Summary Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 85) {
				showLoador({ loador: true });
				downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/sales-team-leave-records?salesTeamId=" +
						row.salesPerson +
						"&fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate,
					ext: "xls",
					openNewTab: false,
					reportName: "Sales Team Leave Balance Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 86) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/sales-team-type-wise-with-state-attendence-summary-report-excel?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson +
						"&stockStakeHolderTypeIds=" +
						row.stockStakeHolderTypeId,
					ext: "xls",
					openNewTab: false,
					reportName: "Attendance Summary Report Team Type Wise",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			} else if (rowData.uniqueIndexValue == 89) {
				showLoador({ loador: true });
				await downloadF({
					isGet: true,
					url:
						endpoint.reportForExcelReportsLatest +
						"/market-summary-report?fromDate=" +
						row.fromDate +
						"&toDate=" +
						row.toDate +
						"&salesTeamId=" +
						row.salesPerson,
					ext: "xls",
					openNewTab: false,
					reportName: "Market Summary Report",
					isShowReportName: true,
					salesPersonName: salesPersonName,
				}).then((response) => {
					if (!response) {
						showNotification({
							msg: serverMsg,
							severity: "error",
						});
					}
					showLoador({ loador: false });
				});
			}
		} else {
			showNotification({ msg: noInternetMsg, severity: "error" });
		}
	};

	rowDataGklAdm = (reportIndexList) => {
		let adminFlagForReports = false;
		let subAdminFlagForReports = false;

		if (
			localStorage.getItem("userTypeId") &&
			localStorage.getItem("userTypeId") == 1
		) {
			adminFlagForReports = true;
		}

		if (
			localStorage.getItem("userTypeId") &&
			localStorage.getItem("userTypeId") == 6
		) {
			subAdminFlagForReports = true;
		}

		let listForReports = [];

		if (reportIndexList.includes("35")) {
			listForReports.push({
				isStatic: true,
				index: 35,
				uniqueIndexValue: 35,
				reportName: "Customer Addition Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributiondevelop/v1/report/customer-additional-report",
				days: 91,
			});
		}

		if (
			(adminFlagForReports || subAdminFlagForReports) &&
			reportIndexList.includes("36")
		) {
			listForReports.push({
				isStatic: true,
				index: 36,
				uniqueIndexValue: 36,
				reportName: "DRCP Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributiondevelop/v1/report/drpc-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("37")) {
			listForReports.push({
				isStatic: true,
				index: 37,
				uniqueIndexValue: 37,
				reportName: "Attendance Summary Report (D0 to D2)",
				isShowReportName: true,
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/attendence-summary-report-excel?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}",
				days: 91,
			});
		}

		if (reportIndexList.includes("38")) {
			listForReports.push({
				isStatic: true,
				index: 38,
				uniqueIndexValue: 38,
				reportName: "Joint Working Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/outlet-joint-survey-report?salesTeamId=&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("39")) {
			listForReports.push({
				isStatic: true,
				index: 39,
				uniqueIndexValue: 39,
				reportName: "Check In Out Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/check-in-out-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("40")) {
			listForReports.push({
				isStatic: true,
				index: 40,
				uniqueIndexValue: 40,
				reportName: "Zero Billing Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/zero-billing-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("41")) {
			listForReports.push({
				isStatic: true,
				index: 41,
				uniqueIndexValue: 41,
				reportName: "Fundamental Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/fundamental-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("42")) {
			listForReports.push({
				isStatic: true,
				index: 42,
				uniqueIndexValue: 42,
				reportName: "Wholesale Target vs Achievement Report (D0 to D2)",
				filter: "fromDate,toDate,channelId,subChannelId,outLetType,salesPerson",
				url: "/api/distribution/v1/export/wholesales-target-vs-achive-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("43")) {
			listForReports.push({
				isStatic: true,
				index: 43,
				uniqueIndexValue: 43,
				reportName: "TA & DA Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/travel-and-daily-allowance-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("44")) {
			listForReports.push({
				isStatic: true,
				index: 44,
				uniqueIndexValue: 44,
				reportName: "Sales Team Ranking (RU) (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/stock-holder-wise-sales-team-with-target-and-achievement?salesTeamId=&flag=0&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("45")) {
			listForReports.push({
				isStatic: true,
				index: 45,
				uniqueIndexValue: 45,
				reportName: "Sales Team Ranking (Value)(D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/stock-holder-wise-sales-team-with-target-and-achievement?salesTeamId=&flag=1&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("46")) {
			listForReports.push({
				isStatic: true,
				index: 46,
				uniqueIndexValue: 46,
				reportName: "Fundamental Summary Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/fundamental-summary-report",
				days: 91,
			});
		}
		if (reportIndexList.includes("47")) {
			listForReports.push({
				isStatic: true,
				index: 47,
				uniqueIndexValue: 47,
				reportName: "Target vs Achievement (RU) (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/target-vs-achievement-by-year-and-sales-team?salesTeamId=&fromDate=&toDate=&flag=0",
				days: 91,
			});
		}
		if (reportIndexList.includes("48")) {
			listForReports.push({
				isStatic: true,
				index: 48,
				uniqueIndexValue: 48,
				reportName: "Target vs Achievement (Value) (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/target-vs-achievement-by-year-and-sales-team?salesTeamId=&fromDate=&toDate=&flag=1",
				days: 91,
			});
		}
		if (reportIndexList.includes("49")) {
			listForReports.push({
				isStatic: true,
				index: 49,
				uniqueIndexValue: 49,
				reportName: "Secondary Sales Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/secondary-sales-report",
				days: 91,
			});
		}
		if (reportIndexList.includes("50")) {
			listForReports.push({
				isStatic: true,
				index: 50,
				uniqueIndexValue: 50,
				reportName: "Focus SKU Target vs Achievement (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/focus-sku-target-vs-achievement-report",
				days: 91,
			});
		}

		if (adminFlagForReports && reportIndexList.includes("51")) {
			listForReports.push({
				index: 51,
				uniqueIndexValue: 51,
				reportName: "DRCP Report For All",
				filter: "",
				url: "/api/distributionreport/v1/report/drpc-report-for-all",
				days: 91,
			});
		}

		if (
			(adminFlagForReports || subAdminFlagForReports) &&
			reportIndexList.includes("52")
		) {
			listForReports.push({
				isStatic: true,
				index: 52,
				uniqueIndexValue: 52,
				reportName: "DRCP Report for Inactive Sales Person (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributiondevelop/v1/report/drpc-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("53")) {
			listForReports.push({
				isStatic: true,
				index: 53,
				uniqueIndexValue: 53,
				reportName: "Unvisited Outlet Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributiondevelop/v1/report/unvisited-outlet-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("54")) {
			listForReports.push({
				isStatic: true,
				index: 54,
				uniqueIndexValue: 54,
				reportName: "Check In Out Summary Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributiondevelop/v1/export/check-in-out-summary-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("55")) {
			listForReports.push({
				isStatic: true,
				index: 55,
				uniqueIndexValue: 55,
				reportName: "Product Distribution Report  (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/product-distribution-report?fromDate=&toDate=&salesTeamId=",
				days: 91,
			});
		}

		if (reportIndexList.includes("56")) {
			listForReports.push({
				index: 56,
				uniqueIndexValue: 56,
				reportName: "FG Production Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/fg-production?fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("57")) {
			listForReports.push({
				index: 57,
				uniqueIndexValue: 57,
				reportName: "Purchase Return Quantity Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/grn?fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("58")) {
			listForReports.push({
				index: 58,
				uniqueIndexValue: 58,
				reportName: "Invoice Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/invoice?fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}
		if (reportIndexList.includes("59")) {
			listForReports.push({
				index: 59,
				uniqueIndexValue: 59,
				reportName: "Date Wise In-Stock Report(D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/month-wise-and-date-wise-stock-report?fromDate={fromDate}&toDate={toDate}&status=1",
				days: 91,
			});
		}
		if (reportIndexList.includes("60")) {
			listForReports.push({
				isStatic: true,
				index: 60,
				uniqueIndexValue: 60,
				reportName: "Active DRCP Report for Manager (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/drpc-report-for-manager",
				days: 91,
			});
		}
		if (reportIndexList.includes("61")) {
			listForReports.push({
				isStatic: true,
				index: 61,
				uniqueIndexValue: 61,
				reportName: "Inactive DRCP Report for Manager (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/drpc-report-for-manager",
				days: 91,
			});
		}
		if (reportIndexList.includes("62")) {
			listForReports.push({
				isStatic: true,
				index: 62,
				uniqueIndexValue: 62,
				reportName: "Claim Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/claim-report?salesTeamId=&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("63")) {
			listForReports.push({
				isStatic: true,
				index: 63,
				uniqueIndexValue: 63,
				reportName: "Not Mapped Beat Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "api/distribution/v1/report/not-mapped-beat-sales-teams?salesTeamId=&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("64")) {
			listForReports.push({
				isStatic: true,
				index: 64,
				uniqueIndexValue: 64,
				reportName: "End User Allowance Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/get-end-user-allowance-data?salesTeamId=&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("65")) {
			listForReports.push({
				isStatic: true,
				index: 65,
				uniqueIndexValue: 65,
				reportName: "Distributor Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/monthly-sale-bill-analysis/new-by-sales-team",
				days: 91,
			});
		}

		if (reportIndexList.includes("66")) {
			listForReports.push({
				isStatic: true,
				index: 66,
				uniqueIndexValue: 66,
				reportName: "Expense Report (D0 to D3)",
				filter: "fromDate,toDate,salesPerson,stockStakeHolderTypeId",
				url: "/api/distribution/v1/report/consolidated-expense-report-with-info?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}&stockStakeHolderTypeIds={stockStakeHolderTypeId}",
				days: 91,
			});
		}

		if (reportIndexList.includes("67")) {
			listForReports.push({
				isStatic: true,
				index: 67,
				uniqueIndexValue: 67,
				reportName: "Chef Working Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/export/chef-outlet-joint-survey-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("68")) {
			listForReports.push({
				isStatic: true,
				index: 68,
				uniqueIndexValue: 68,
				reportName: "Feedback Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/feedback-report?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}",
				days: 91,
			});
		}

		if (reportIndexList.includes("69")) {
			listForReports.push({
				isStatic: true,
				index: 69,
				uniqueIndexValue: 69,
				reportName: "Feedback Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/feedback-report-by-type?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}",
				days: 91,
			});
		}

		if (reportIndexList.includes("70")) {
			listForReports.push({
				isStatic: true,
				index: 70,
				uniqueIndexValue: 70,
				reportName: "Outlet Feedback Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distribution/v1/report/feedback-report-by-type?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}",
				days: 91,
			});
		}

		if (
			(adminFlagForReports || subAdminFlagForReports) &&
			reportIndexList.includes("71")
		) {
			listForReports.push({
				isStatic: true,
				index: 71,
				uniqueIndexValue: 71,
				reportName: "Expense Report For Admin (D0 to D3)",
				filter: "fromDate,toDate,salesPerson,stockStakeHolderTypeId",
				url: "/api/distribution/v1/report/consolidated-expense-report-with-info-with-distance-travelled?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}&stockStakeHolderTypeIds={stockStakeHolderTypeId}",
				days: 91,
			});
		}

		if (
			(adminFlagForReports || subAdminFlagForReports) &&
			reportIndexList.includes("72")
		) {
			listForReports.push({
				index: 72,
				uniqueIndexValue: 72,
				reportName: "Active Sales Team Report (D2)",
				filter: "salesPerson",
				url: "/api/distributionreport/v1/report/active-inactive-sales-team-report?salesTeamId={salesPerson}&status=1",
				days: 91,
			});
		}

		if (
			(adminFlagForReports || subAdminFlagForReports) &&
			reportIndexList.includes("73")
		) {
			listForReports.push({
				index: 73,
				uniqueIndexValue: 73,
				reportName: "Inactive Sales Team Report (D2)",
				filter: "salesPerson",
				url: "/api/distributionreport/v1/report/active-inactive-sales-team-report?salesTeamId={salesPerson}&status=0",
				days: 91,
			});
		}

		if (reportIndexList.includes("74")) {
			listForReports.push({
				isStatic: true,
				index: 74,
				uniqueIndexValue: 74,
				reportName: "Attendance Summary Report Team Type Wise (D0 to D3)",
				filter: "fromDate,toDate,salesPerson,stockStakeHolderTypeId",
				url: "/api/distributionreport/v1/report/sales-team-type-wise-attendence-summary-report-excel?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}&stockStakeHolderTypeIds={stockStakeHolderTypeId}",
				days: 91,
			});
		}

		if (reportIndexList.includes("75")) {
			listForReports.push({
				isStatic: true,
				index: 75,
				uniqueIndexValue: 75,
				reportName: "Report For Beats Without Mapped End Users",
				filter: "",
				url: "/api/distributionreport/v1/report/beat-without-mapped-to-end-user-report",
				days: 91,
			});
		}

		if (reportIndexList.includes("76")) {
			listForReports.push({
				isStatic: true,
				index: 76,
				uniqueIndexValue: 76,
				reportName: "DA Beat Master Report (D2)",
				filter: "salesPerson",
				url: "/api/distributionreport/v1/report/daily-allowance-beat-master-report?salesTeamId={salesPerson}",
				days: 91,
			});
		}

		if (reportIndexList.includes("77")) {
			listForReports.push({
				isStatic: true,
				index: 77,
				uniqueIndexValue: 77,
				reportName: "Market Visit Report (D0 to D2)",
				filter: "salesPerson,fromDate,toDate",
				url: "/api/distributionreport/v1/report/market-visit-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("78")) {
			listForReports.push({
				isStatic: true,
				index: 78,
				uniqueIndexValue: 78,
				reportName: "Enquiry Master Report (D0 to D2)",
				filter: "salesPerson,fromDate,toDate",
				url: "/api/distributionreport/v1/report/enquiry-master-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("79")) {
			listForReports.push({
				isStatic: true,
				index: 79,
				uniqueIndexValue: 79,
				reportName: "Chef Working Product Wise Detail Report (D0 to D2)",
				filter: "salesPerson,fromDate,toDate",
				url: "/api/distributionreport/v1/export/chef-outlet-joint-survey-sub-detail-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("80")) {
			listForReports.push({
				isStatic: true,
				index: 80,
				uniqueIndexValue: 80,
				reportName: "Market Visit Report In Detail (D0 to D2)",
				filter: "salesPerson,fromDate,toDate",
				url: "/api/distributionreport/v1/export/promoter-outlet-joint-survey-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("81")) {
			listForReports.push({
				isStatic: true,
				index: 81,
				uniqueIndexValue: 81,
				reportName: "Outlet Credit Note report (D0 to D1)",
				filter: "fromDate,toDate",
				url: "/api/distributionreport/v1/report/outlet-credit-note?fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("82")) {
			listForReports.push({
				isStatic: true,
				index: 82,
				uniqueIndexValue: 82,
				reportName: "Check In Out Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/check-in-out-report-with-state",
				days: 91,
			});
		}

		if (reportIndexList.includes("83")) {
			listForReports.push({
				isStatic: true,
				index: 83,
				uniqueIndexValue: 83,
				reportName: "Fundamental Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/fundamental-report-with-state",
				days: 91,
			});
		}

		if (reportIndexList.includes("84")) {
			listForReports.push({
				isStatic: true,
				index: 84,
				uniqueIndexValue: 84,
				reportName: "Fundamental Summary Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/fundamental-summary-report-with-state",
				days: 91,
			});
		}

		if (reportIndexList.includes("85")) {
			listForReports.push({
				isStatic: true,
				index: 85,
				uniqueIndexValue: 85,
				reportName: "Sales Team Leave Balance Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/sales-team-leave-records?salesTeamId=&fromDate=&toDate=",
				days: 91,
			});
		}

		if (reportIndexList.includes("86")) {
			listForReports.push({
				isStatic: true,
				index: 86,
				uniqueIndexValue: 86,
				reportName: "Attendance Summary Report Team Type Wise (D0 to D3)",
				filter: "fromDate,toDate,salesPerson,stockStakeHolderTypeId",
				url: "/api/distributionreport/v1/report/attendence-summary-report-excel?fromDate={fromDate}&toDate={toDate}&salesTeamId={salesPerson}",
				days: 91,
			});
		}

		if (reportIndexList.includes("87")) {
			listForReports.push({
				// isStatic: true,
				index: 87,
				uniqueIndexValue: 87,
				reportName: "Day Wise Analysis Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/day-wise-analysis-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("88")) {
			listForReports.push({
				// isStatic: true,
				index: 88,
				uniqueIndexValue: 88,
				reportName: "Month Wise Analysis Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/month-wise-analysis-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		if (reportIndexList.includes("89")) {
			listForReports.push({
				isStatic: true,
				index: 89,
				uniqueIndexValue: 89,
				reportName: "Market Summary Report (D0 to D2)",
				filter: "fromDate,toDate,salesPerson",
				url: "/api/distributionreport/v1/report/market-summary-report?salesTeamId={salesPerson}&fromDate={fromDate}&toDate={toDate}",
				days: 91,
			});
		}

		const finalReportList = listForReports.map((dataObj, index) => {
			return {
				...dataObj,
				index: index + 1,
			};
		});

		this.setState({ listForReports: finalReportList });
	};

	render() {
		const { dynamicMasterData, listForReports, uniqueReportSet } = this.state;

		const showCompanyFlag =
			localStorage.getItem("showCompanyFlag") !== null
				? localStorage.getItem("showCompanyFlag")
				: "";

		const userTypeId =
			localStorage.getItem("userTypeId") !== null
				? localStorage.getItem("userTypeId")
				: "";

		return (
			<>
				<DynamicMainScreen
					maxDateValid={true}
					getExcel={this.getExcelByReport}
					screenTitle={ExcelReportsJson.screenTitle}
					fieldMeta={ExcelReportsJson.fieldMetaForSalesTeamReports}
					buttonCenter={ExcelReportsJson.buttonCenter}
					dynamicMasterData={dynamicMasterData}
					getListById={this.getListById}
					searchButton={ExcelReportsJson.searchButton}
					PDFButton={ExcelReportsJson.PDFButton}
					EXCELButton={ExcelReportsJson.EXCELButton}
					baseIdColumn={ExcelReportsJson.baseIdColumn}
					apiBaseURL={ExcelReportsJson.apiBaseURL}
					marginTop={ExcelReportsJson.marginTop}
					isNoteValue={salesTeamExcelReportsNoteWith91DaysValidation}
					openNewTab={true}
					isDaysValidationAppliedBySettingKey={true}
					rowData={
						showCompanyFlag == 4 && userTypeId == 6
							? listForReports.filter((report) =>
									uniqueReportSet.has(report.uniqueIndexValue),
								)
							: listForReports
					}
				/>
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	stockStakeHolderType: state.stockStakeHolderType,
	stakeholderList: state.stockholder,
	salesPersonList: state.salesExecutive,
});
const mapDispatchToProps = {
	showNotification,
	showLoador,
	getSalesExecutiveByUserType,
	getSalesExecutiveByUserTypeAndRegion,
	getBelowSalesTeamList,
	getStockStakeHolderTypeBySalesTeamId,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(ExcelReportsForSalesTeams);
